import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PreventionAlert } from 'types/preventionAlerts';
import { PreventionRow } from './PreventionRow';
import { RowSubtitle } from './DuePreventionsSection.styles';

export const OneTimeRow: React.FC<{ alert: PreventionAlert; name: string }> = ({ alert, name }) => {
  const { t } = useTranslation();

  return (
    <PreventionRow alert={alert} name={name}>
      <RowSubtitle>{t('result.preventions.lastPerformed.neverDone')}</RowSubtitle>
    </PreventionRow>
  );
};
